import { useContent } from '../../../hooks/use-server-content';
import { VehicleAttributes } from '../../../models/vehicle-attributes';
import { getVehicleDataSelector } from '../../../services/content-service/content-service-util';

export interface DylLandingDynamicProps {
    third5050CardTitle: string;
    third5050CardBody: string;
    third5050CardImage: string;
    third5050CardImageAltText: string;
    third5050CardImageSide: string;
    third5050CardCtaLabel: string;
    third5050CardCtaLink: string;
    third5050CardDisclaimer: string;
    blackLabelTitle: string;
    blackLabelBody: string;
    blackLabelDesktopImage: string;
    blackLabelDesktopAltText: string;
    blackLabelMobileImage: string;
    blackLabelMobileAltText: string;
    blackLabelButtonLabel: string;
    blackLabelButtonLink: string;
    blackLabelButtonAriaLabel: string;
    blackLabelDisclaimer: string;
}
export const useDylLandingDynamicContent = (
    vehicleAttributes: VehicleAttributes
): DylLandingDynamicProps | null => {
    const [content, getValueByName] = useContent(
        'vehicle-data',
        getVehicleDataSelector('dyl-landing-dynamic', vehicleAttributes),
        undefined,
        true
    );
    let contentFragment: any = {};
    if (content) {
        content?.elements.forEach(element => {
            contentFragment[`${element.name}`] = getValueByName(
                `${element.name}`
            );
        });
    }
    if (contentFragment) {
        if (contentFragment.hide) {
            contentFragment = null;
        }
    }
    return contentFragment as DylLandingDynamicProps;
};
